import ApplicationLayout from './ApplicationLayout';
import { EmbeddedBackButtonContainer } from './ApplicationLayout';

export { EmbeddedBackButtonContainer };
export default ApplicationLayout;
